import React from "react";
import ProductDetail from ".";
import { MODEL_KEY } from "config/products";

function IphoneDuo() {
  return <ProductDetail modelId={MODEL_KEY.IPHONEDUO} />;
}

export default IphoneDuo;
